import { Injectable, Inject, OnDestroy, OnInit } from '@angular/core';
import { DwAttributeType, DwContextDefinition, DwContextRepositoryService, DwControlType, DwCustomContextBase, DwCustomContextDefinition, 
         DwExpressionAttribute, DwQueryHelper,
         DwOrmDataServiceToken, DwOrmDataService, DwLookupInfo, DwMetaDataServiceToken, DwMetaDataService } from '@devwareapps/devware-cap';
import { RoVehicleEntity, RoAuctionEntity, MaintenanceEntity, AuctionEntity, FleetVehicleEntity, FleetMetaDataItemNames, 
         FleetMetaDataLookups, FleetMetaData, AuctionMetaData } from '../meta-data/fleet-meta-data.service';
import { map, mergeMap } from 'rxjs/operators';
import { combineLatest, Observable, Subscription, of } from 'rxjs';
import { AppMetaDataService, AppMetaDataItemNames } from '../../../meta-data/app-meta-data.service';
import * as moment_ from 'moment';
const moment = moment_;

@DwCustomContextDefinition({
    keyName: 'FleetVehicleContext',
    display: 'Fleet Vehicle - Details',
    isGlobal: false,
    parentItem: FleetMetaDataItemNames.FleetVehicle
})
@Injectable()
export class FleetVehicleContextService extends DwCustomContextBase{
        constructor(
        @Inject(DwOrmDataServiceToken) private dataService: DwOrmDataService,
        @Inject(DwMetaDataServiceToken) private dwMetaDataService: DwMetaDataService,
    ){
        super();
    }

    setupContextDefinition(contextDef: DwContextDefinition) {
        contextDef.getCustomContextFunction = (resolvedContext => {
            const veh: FleetVehicleEntity = resolvedContext?.data;
            if (veh == undefined) return { PlateStatus : 'Active' };
            if (veh?.PlateExpirationDate == undefined) return { PlateStatus : 'Active' };

            const roAucOb = this.getRoAuc(veh.VehicleId);
            
            return combineLatest([roAucOb])
                    .pipe(mergeMap(([roAuc]) => {
                        const aid: number = roAuc?.AuctionId;

                        const exp = moment.utc(veh?.PlateExpirationDate).local().endOf('day');
                        const expiringThreshold = moment.utc(veh?.PlateExpirationDate).local().endOf('day').subtract(90, 'd');
                        const today = moment().endOf('day');
                                
                        //'Expired':  When the current date is greater than or equal to the 'Plate Expiration' date.
                        const expired = exp.isValid() && today >= exp;
                                
                        //'Expiring':  When it is 90 days (or less) before the 'Plate Expiration' date 
                        const expiring = !expired && exp.isValid() && today >= expiringThreshold;
                                
                        //'Active':  When the Plate Expiration Date is not in an 'Expired' or "Expiring'  state 
                        const active = !expired && !expiring;
                                
                        const msg = expired ? 'Expired' : expiring ? 'Expiring' : 'Active';
                        return of({ PlateStatus : `<span class="plate-${msg}">${msg}</span>`, AuctionId: aid });
                    }));
        });
        contextDef.attributes = [];
        const attrs = contextDef.attributes;
        var attrPlateStatus : DwExpressionAttribute = this.addProperty( attrs, 'PlateStatus', 'Plate Status', 
                                                                        DwAttributeType.Text, DwControlType.Textbox);
        var attrAuctionId : DwExpressionAttribute = this.addProperty(   attrs, 'AuctionId', 'Auction Id', 
                                                                        DwAttributeType.Integer, DwControlType.NumericTextBox);
    }
    getRoAuc(vehId : number) : Observable<RoAuctionEntity> {
        const md = new AppMetaDataService();
        const qh = new DwQueryHelper();
        const query = md.Auction.CreateQuery();
        query.AddFilterAnd(qh.filters.Equal(md.Auction.VehicleId, vehId));
        return this.dataService.executeQuerySingle(query);
    }
}